import styled, { css } from 'styled-components';
import BaseProgressLevel from 'src/components/ProgressLevel';

export const ProgressLevel = styled(BaseProgressLevel)(
  ({ theme }) => css`
    margin: ${theme.sz.s3} 0;
    width: 100%;
  `,
);

export const LoaderContainer = styled.div(
  ({ theme }) => css`
    margin: ${theme.sz.s32} auto 0 auto;
    width: ${theme.sz.s20};
  `,
);

export const CardsWrapper = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.sz.s6};
    display: flex;
    gap: ${theme.sz.s6};
    align-items: start;

    @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
      margin-top: ${theme.sz.s3};
    }
  `,
);

export const BuddiesPromotionCardDesktop = styled.div(
  ({ theme }) => css`
    max-width: ${theme.sz.s};

    @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
      display: none;
    }
  `,
);

export const BuddiesPromotionCardMobile = styled.div(
  ({ theme }) => css`
    display: none;
    max-width: ${theme.sz.ml};
    margin: ${theme.sz.s2} 0;
    justify-self: center;

    @media (max-width: ${theme.sz.maxMobileBreakpoint}) {
      display: block;
    }
  `,
);
